export const CREATE_MERCHANT_SAGE_CONNECTION = gql`
    mutation CreateMerchantSageConnection($input: SageInput!) {
        createMerchantSageConnection(input: $input)
    }
`;

export const SEND_SEPA_MANDATE = gql`
    mutation SendSEPAMandate($input: SepaMandateInput!) {
        sendSepaMandate(input: $input)
    }
`;
